<template>
  <div>
    <h4>Definições</h4>
    <div class="row no-gutters border overflow-hidden rounded-lg mb-3">
      <label class="cursor-pointer custom-checkbox-cursor p-3 mb-0 w-100">
        <b-form-group class="mb-0">
          <b-form-checkbox
            switch
            v-model="plano.visivel"
            value="1"
            class="text-body cursor-pointer"
          >
            O plano está disponível?
          </b-form-checkbox>
        </b-form-group>
      </label>
      <hr class="w-100 my-0" />
      <label class="cursor-pointer custom-checkbox-cursor p-3 mb-0 w-100">
        <b-form-group class="mb-0">
          <b-form-checkbox
            switch
            v-model="plano.venda_online"
            class="text-body cursor-pointer mb-0"
          >
            <div class="d-inline-flex align-items-center">
              <b class="font-weight-600 text-default lh-1 mr-1">Venda online</b>
              <span class="text-gray text-sm lh-1">
                · Utiliza o sistema de checkout da plataforma. Desativar retoma
                o atendimento manual.
              </span>
            </div>
          </b-form-checkbox>
        </b-form-group>
      </label>
      <hr class="w-100 my-0" />
      <label class="cursor-pointer custom-checkbox-cursor p-3 mb-0 w-100">
        <b-form-group class="mb-0">
          <b-form-checkbox
            switch
            v-model="plano.plano_consultor"
            name="plano_consultor"
            :value="1"
            :unchecked-value="0"
            class="cursor-pointer"
          >
            Plano destinado a
            <b class="font-weight-600 text-default">consultores</b>?
          </b-form-checkbox>
        </b-form-group>
      </label>
    </div>

    <h4>Identificação</h4>
    <b-row class="border rounded-lg mb-3 mx-0 pt-3">
      <b-col cols="12">
        <b-form-group label="Nome:" class="w-100">
          <b-form-input
            v-model="plano.nome"
            placeholder="Nome"
            :state="validateState('nome')"
          />
          <b-form-invalid-feedback>
            Nome é um campo obrigatório.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group label="Observação Interna" class="w-100">
          <b-form-textarea
            placeholder="Observação Interna..."
            v-model="plano.descricao"
            rows="3"
          >
          </b-form-textarea>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group label="Benefícios" class="custom-editor">
          <Editor
            v-model="plano.beneficios"
            :custom-config="customConfigEditor"
          />
          <small class="text-muted d-block mt-2">
            Os benefícios cadastrados aqui aparecem em destaque na página de
            exibição da oferta sob medida para o usuário.
          </small>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useNamespacedState } from "vuex-composition-helpers";
import { minLength, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default defineComponent({
  components: { Editor: () => import("@/components/Form/Editor.vue") },
  setup(props) {
    const planoStates = useNamespacedState("planos", ["plano"]);
    const customConfigEditor = {
      language: "pt-br",
      toolbar: [
        "bold",
        "italic",
        "numberedList",
        "bulletedList",
        "|",
        "undo",
        "redo",
      ],
      placeholder: "Benefícios...",
    };

    const rules = {
      plano: {
        nome: {
          required,
          minLength: minLength(3),
        },
      },
    };

    const v$ = useVuelidate(rules, planoStates);

    function validateState(name) {
      const $field = Reflect.get(v$.value?.plano, name) || {};

      return $field.$dirty ? !$field.$error : null;
    }

    function isValid() {
      v$.value?.plano?.$touch?.();
      return !v$.value?.plano?.$anyError;
    }

    return {
      ...planoStates,
      customConfigEditor,
      validateState,
      isValid,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep .custom-checkbox-cursor {
  .custom-control-label {
    cursor: pointer !important;
  }

  &:hover {
    background-color: rgba(var(--exitos-rgb), 0.075);

    .custom-control-label {
      color: var(--exitos);
    }
  }
}

::v-deep .custom-editor {
  --ck-border-radius: 0.375rem;
}

.lh-1 {
  line-height: 1;
}
</style>
